import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import API_BASE from "../../config";
import { pick } from "../sitecontent/siteContent";
import PublicUserBadge from "../../components/PublicUserBadge";
import Markdown from "../../components/Markdown";
import s from "./HomePage.module.css";


/* ─── 3D illustrated icons (orange laptop w/ clipboard, purple board w/ chat) ─── */
const IconEnrollScene = (p) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" {...p}>
    <defs>
      <linearGradient id="lapBody" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#ff9b4a"/>
        <stop offset="1" stopColor="#e06b1a"/>
      </linearGradient>
      <linearGradient id="lapScreen" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#ffb066"/>
        <stop offset="1" stopColor="#d65d10"/>
      </linearGradient>
      <linearGradient id="clip" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#ffd6a3"/>
        <stop offset="1" stopColor="#f2a258"/>
      </linearGradient>
    </defs>
    {/* laptop body */}
    <rect x="18" y="28" width="78" height="52" rx="8" fill="url(#lapBody)" stroke="#b84a08" strokeWidth="2.5"/>
    {/* laptop screen */}
    <rect x="26" y="36" width="62" height="36" rx="3" fill="url(#lapScreen)" stroke="#b84a08" strokeWidth="2"/>
    {/* check on screen */}
    <path d="M44 54 l8 8 l18 -18" fill="none" stroke="#ffffff" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
    {/* laptop base */}
    <path d="M10 84 h94 a6 6 0 0 1 -6 6 H16 a6 6 0 0 1 -6 -6 z" fill="#e06b1a" stroke="#b84a08" strokeWidth="2.5"/>
    {/* clipboard in front-right */}
    <rect x="66" y="60" width="32" height="42" rx="3" fill="url(#clip)" stroke="#b84a08" strokeWidth="2.2"/>
    <rect x="74" y="56" width="16" height="8" rx="2" fill="#e06b1a" stroke="#b84a08" strokeWidth="2"/>
    <path d="M72 74 h20 M72 82 h20 M72 90 h14" stroke="#b84a08" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const IconAnnounceClipboard = (p) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 160" {...p}>
    <defs>
      <linearGradient id="cb_back" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#a02828"/>
        <stop offset="1" stopColor="#5a1616"/>
      </linearGradient>
      <linearGradient id="cb_paper" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#fffaf0"/>
        <stop offset="1" stopColor="#ecd9b0"/>
      </linearGradient>
      <linearGradient id="cb_clip" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#d9d9d9"/>
        <stop offset=".55" stopColor="#8a8a8a"/>
        <stop offset="1" stopColor="#5a5a5a"/>
      </linearGradient>
      <radialGradient id="cb_check" cx=".4" cy=".3" r=".9">
        <stop offset="0" stopColor="#ff9a5e"/>
        <stop offset="1" stopColor="#d84a14"/>
      </radialGradient>
      <filter id="cb_shadow" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="3"/>
        <feOffset dx="0" dy="4"/>
        <feComponentTransfer><feFuncA type="linear" slope=".35"/></feComponentTransfer>
        <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
    </defs>
    <g filter="url(#cb_shadow)">
      {/* board */}
      <rect x="24" y="24" width="112" height="122" rx="10" fill="url(#cb_back)"/>
      {/* body highlight */}
      <rect x="24" y="24" width="112" height="22" rx="10" fill="#ffffff" opacity=".10"/>
      {/* paper */}
      <rect x="34" y="40" width="92" height="98" rx="5" fill="url(#cb_paper)"/>
      <rect x="34" y="40" width="92" height="10" rx="5" fill="#ffffff" opacity=".55"/>
      {/* clip */}
      <rect x="62" y="16" width="36" height="18" rx="5" fill="url(#cb_clip)"/>
      <rect x="66" y="12" width="28" height="10" rx="3" fill="#6a6a6a"/>
      <rect x="62" y="16" width="36" height="5" rx="3" fill="#ffffff" opacity=".35"/>
      {/* checked rows */}
      <rect x="46" y="62" width="12" height="12" rx="2" fill="#ffffff" stroke="#b68b1e" strokeWidth="1.5"/>
      <path d="M48 68 l3 3 l5 -6" fill="none" stroke="url(#cb_check)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      <rect x="64" y="66" width="48" height="4" rx="2" fill="#b68b1e"/>

      <rect x="46" y="84" width="12" height="12" rx="2" fill="#ffffff" stroke="#b68b1e" strokeWidth="1.5"/>
      <path d="M48 90 l3 3 l5 -6" fill="none" stroke="url(#cb_check)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      <rect x="64" y="88" width="44" height="4" rx="2" fill="#b68b1e"/>

      <rect x="46" y="106" width="12" height="12" rx="2" fill="#ffffff" stroke="#b68b1e" strokeWidth="1.5"/>
      <rect x="64" y="110" width="40" height="4" rx="2" fill="#b68b1e"/>
    </g>
  </svg>
);

const IconSchedulePhone = (p) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 160" {...p}>
    <defs>
      <linearGradient id="ph_body" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#c03232"/>
        <stop offset=".5" stopColor="#7a1c1c"/>
        <stop offset="1" stopColor="#3a0a0a"/>
      </linearGradient>
      <linearGradient id="ph_screen" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#3a0a0a"/>
        <stop offset="1" stopColor="#6b1d1d"/>
      </linearGradient>
      <linearGradient id="ph_hi" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stopColor="#ffffff" stopOpacity=".0"/>
        <stop offset=".2" stopColor="#ffffff" stopOpacity=".35"/>
        <stop offset=".3" stopColor="#ffffff" stopOpacity=".0"/>
      </linearGradient>
      <filter id="ph_shadow" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="3"/>
        <feOffset dx="0" dy="5"/>
        <feComponentTransfer><feFuncA type="linear" slope=".4"/></feComponentTransfer>
        <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
    </defs>
    <g filter="url(#ph_shadow)">
      <rect x="50" y="14" width="60" height="132" rx="14" fill="url(#ph_body)"/>
      <rect x="50" y="14" width="60" height="132" rx="14" fill="url(#ph_hi)"/>
      {/* inner screen */}
      <rect x="58" y="26" width="44" height="100" rx="6" fill="url(#ph_screen)" stroke="#2a0808" strokeWidth="1.5"/>
      <rect x="60" y="28" width="40" height="12" rx="4" fill="#ffffff" opacity=".08"/>
      {/* home indicator */}
      <rect x="74" y="134" width="12" height="4" rx="2" fill="#ffffff" opacity=".6"/>
      {/* side button */}
      <rect x="108" y="44" width="4" height="20" rx="2" fill="#2a0808"/>
    </g>
  </svg>
);

const IconDashboardLaptop = (p) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 160" {...p}>
    <defs>
      <linearGradient id="dl_lid" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#6db3ff"/>
        <stop offset="1" stopColor="#2563c9"/>
      </linearGradient>
      <linearGradient id="dl_base" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#3a7edb"/>
        <stop offset="1" stopColor="#1f4b99"/>
      </linearGradient>
      <linearGradient id="dl_win" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#7fb8ff"/>
        <stop offset="1" stopColor="#3a7edb"/>
      </linearGradient>
      <radialGradient id="dl_pie" cx=".35" cy=".3" r=".9">
        <stop offset="0" stopColor="#a3d1ff"/>
        <stop offset="1" stopColor="#1f4b99"/>
      </radialGradient>
      <filter id="dl_sh" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="3"/>
        <feOffset dx="0" dy="5"/>
        <feComponentTransfer><feFuncA type="linear" slope=".3"/></feComponentTransfer>
        <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
    </defs>
    <g filter="url(#dl_sh)">
      {/* laptop lid */}
      <rect x="18" y="20" width="104" height="78" rx="5" fill="url(#dl_lid)" stroke="#1f4b99" strokeWidth="1.5"/>
      <rect x="24" y="26" width="92" height="66" rx="2" fill="#cfe6ff"/>
      {/* user card */}
      <rect x="28" y="32" width="30" height="52" rx="2" fill="url(#dl_win)"/>
      <circle cx="43" cy="46" r="6" fill="none" stroke="#ffffff" strokeWidth="2"/>
      <path d="M34 64 a9 9 0 0 1 18 0" fill="none" stroke="#ffffff" strokeWidth="2"/>
      <rect x="32" y="70" width="10" height="10" rx="1" fill="#ffffff" opacity=".6"/>
      <rect x="44" y="70" width="10" height="10" rx="1" fill="#ffffff" opacity=".6"/>
      {/* text rows */}
      <circle cx="64" cy="40" r="1.5" fill="#ffffff"/>
      <rect x="68" y="38" width="30" height="4" rx="1" fill="#ffffff"/>
      <circle cx="64" cy="50" r="1.5" fill="#ffffff"/>
      <rect x="68" y="48" width="36" height="4" rx="1" fill="#ffffff" opacity=".8"/>
      <circle cx="64" cy="60" r="1.5" fill="#ffffff"/>
      <rect x="68" y="58" width="28" height="4" rx="1" fill="#ffffff" opacity=".8"/>
      <circle cx="64" cy="70" r="1.5" fill="#ffffff"/>
      <rect x="68" y="68" width="32" height="4" rx="1" fill="#ffffff" opacity=".8"/>
      {/* pie chart */}
      <circle cx="120" cy="56" r="18" fill="url(#dl_pie)" stroke="#1f4b99" strokeWidth="1.5"/>
      <path d="M120 56 L138 56 A18 18 0 0 0 128 40 z" fill="#a3d1ff"/>
      <path d="M120 56 L128 40 A18 18 0 0 0 108 50 z" fill="#6db3ff" opacity=".85"/>
      {/* base */}
      <path d="M8 104 h144 l-8 14 H16 z" fill="url(#dl_base)" stroke="#1f4b99" strokeWidth="1.5"/>
      <rect x="62" y="106" width="36" height="3" rx="1" fill="#1f4b99"/>
    </g>
  </svg>
);

const IconIntegrateLaptop = (p) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 160" {...p}>
    <defs>
      <linearGradient id="il_lid" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#3a3a3a"/>
        <stop offset="1" stopColor="#151515"/>
      </linearGradient>
      <linearGradient id="il_base" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#d9dde3"/>
        <stop offset="1" stopColor="#8a909a"/>
      </linearGradient>
      <linearGradient id="il_win" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#7fb8ff"/>
        <stop offset="1" stopColor="#3a7edb"/>
      </linearGradient>
      <radialGradient id="il_globe" cx=".4" cy=".35" r=".7">
        <stop offset="0" stopColor="#a3d1ff"/>
        <stop offset="1" stopColor="#1f4b99"/>
      </radialGradient>
      <filter id="il_sh" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="3"/>
        <feOffset dx="0" dy="5"/>
        <feComponentTransfer><feFuncA type="linear" slope=".3"/></feComponentTransfer>
        <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
    </defs>
    <g filter="url(#il_sh)">
      {/* laptop lid */}
      <rect x="20" y="32" width="100" height="68" rx="4" fill="url(#il_lid)"/>
      <rect x="26" y="38" width="88" height="56" rx="2" fill="#2a2a2a"/>
      {/* browser window floating */}
      <rect x="32" y="22" width="108" height="70" rx="5" fill="url(#il_win)" stroke="#1f4b99" strokeWidth="1.5"/>
      <rect x="32" y="22" width="108" height="12" rx="5" fill="#2e6cc0"/>
      <circle cx="40" cy="28" r="2" fill="#ef4444"/>
      <circle cx="48" cy="28" r="2" fill="#eab308"/>
      <circle cx="56" cy="28" r="2" fill="#22c55e"/>
      <rect x="66" y="24" width="66" height="8" rx="4" fill="#eaf3ff"/>
      <circle cx="127" cy="28" r="2.2" fill="none" stroke="#1f4b99" strokeWidth="1.2"/>
      {/* globe */}
      <circle cx="86" cy="66" r="16" fill="url(#il_globe)"/>
      <ellipse cx="86" cy="66" rx="16" ry="6" fill="none" stroke="#ffffff" strokeWidth="1.2" opacity=".7"/>
      <ellipse cx="86" cy="66" rx="6" ry="16" fill="none" stroke="#ffffff" strokeWidth="1.2" opacity=".7"/>
      <path d="M70 66 h32" stroke="#ffffff" strokeWidth="1.2" opacity=".7"/>
      {/* grad cap */}
      <path d="M68 58 l18 -8 l18 8 l-18 8 z" fill="#1a1a1a"/>
      <path d="M74 61 v6 a12 5 0 0 0 24 0 v-6" fill="#1a1a1a"/>
      <circle cx="104" cy="60" r="1.8" fill="#eab308"/>
      <path d="M104 60 v8" stroke="#eab308" strokeWidth="1.6"/>
      <circle cx="104" cy="70" r="1.6" fill="#eab308"/>
      {/* base */}
      <path d="M10 104 h140 l-8 14 H18 z" fill="url(#il_base)" stroke="#8a909a" strokeWidth="1.2"/>
      <rect x="72" y="106" width="16" height="3" rx="1" fill="#8a909a"/>
      <circle cx="32" cy="111" r="1.2" fill="#22c55e"/>
    </g>
  </svg>
);

const IconSecurityDoc = (p) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 160" {...p}>
    <defs>
      <linearGradient id="sd_doc" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#3c4754"/>
        <stop offset="1" stopColor="#222a34"/>
      </linearGradient>
      <linearGradient id="sd_shield" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#576472"/>
        <stop offset="1" stopColor="#2f3843"/>
      </linearGradient>
      <filter id="sd_sh" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="3"/>
        <feOffset dx="0" dy="5"/>
        <feComponentTransfer><feFuncA type="linear" slope=".3"/></feComponentTransfer>
        <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
    </defs>
    <g filter="url(#sd_sh)">
      {/* document body */}
      <rect x="28" y="16" width="86" height="118" rx="6" fill="url(#sd_doc)" stroke="#e4e7ed" strokeWidth="3"/>
      {/* title bar */}
      <rect x="28" y="16" width="86" height="20" rx="6" fill="#e4e7ed"/>
      <rect x="28" y="30" width="86" height="6" fill="#e4e7ed"/>
      <circle cx="40" cy="26" r="3" fill="#ef4444"/>
      <circle cx="52" cy="26" r="3" fill="#eab308"/>
      <circle cx="64" cy="26" r="3" fill="#22c55e"/>
      {/* colored rows */}
      <circle cx="38" cy="50" r="2" fill="#ffffff"/>
      <rect x="44" y="47" width="58" height="6" rx="3" fill="#eab308"/>
      <circle cx="38" cy="62" r="2" fill="#ffffff"/>
      <rect x="44" y="59" width="50" height="6" rx="3" fill="#ef4444"/>
      <circle cx="38" cy="74" r="2" fill="#ffffff"/>
      <rect x="44" y="71" width="60" height="6" rx="3" fill="#06b6d4"/>
      <circle cx="38" cy="86" r="2" fill="#ffffff"/>
      <rect x="44" y="83" width="52" height="6" rx="3" fill="#eab308"/>
      <circle cx="38" cy="98" r="2" fill="#ffffff"/>
      <rect x="44" y="95" width="48" height="6" rx="3" fill="#06b6d4"/>
      <circle cx="38" cy="110" r="2" fill="#ffffff"/>
      <rect x="44" y="107" width="54" height="6" rx="3" fill="#ef4444"/>
      {/* shield */}
      <path d="M100 70 l24 -4 l24 4 v18 c0 18 -14 30 -24 34 c-10 -4 -24 -16 -24 -34 z"
            fill="url(#sd_shield)" stroke="#e4e7ed" strokeWidth="3"/>
      <path d="M112 94 l8 8 l14 -16" fill="none" stroke="#ffffff" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
  </svg>
);

const IconTuitionLaptop = (p) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 160" {...p}>
    <defs>
      <linearGradient id="lt_body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#fffaf0"/>
        <stop offset=".5" stopColor="#f1dfb3"/>
        <stop offset="1" stopColor="#c9a14a"/>
      </linearGradient>
      <linearGradient id="lt_base" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#e6cf96"/>
        <stop offset="1" stopColor="#a3793a"/>
      </linearGradient>
      <linearGradient id="lt_screen" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#3a0a0a"/>
        <stop offset="1" stopColor="#6b1d1d"/>
      </linearGradient>
      <filter id="lt_shadow" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="3"/>
        <feOffset dx="0" dy="5"/>
        <feComponentTransfer><feFuncA type="linear" slope=".35"/></feComponentTransfer>
        <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
      </filter>
    </defs>
    <g filter="url(#lt_shadow)">
      {/* lid */}
      <rect x="18" y="26" width="124" height="80" rx="7" fill="url(#lt_body)"/>
      {/* inner bezel */}
      <rect x="26" y="34" width="108" height="64" rx="3" fill="url(#lt_screen)"/>
      <rect x="26" y="34" width="108" height="12" rx="3" fill="#ffffff" opacity=".10"/>
      {/* dashboard: left sidebar */}
      <rect x="30" y="38" width="22" height="56" rx="2" fill="#4a1212"/>
      <rect x="33" y="42" width="16" height="3" rx="1" fill="#f4dca0"/>
      <rect x="33" y="48" width="12" height="3" rx="1" fill="#f4dca0" opacity=".7"/>
      <rect x="33" y="54" width="14" height="3" rx="1" fill="#f4dca0" opacity=".7"/>
      <rect x="33" y="60" width="10" height="3" rx="1" fill="#f4dca0" opacity=".7"/>
      {/* right content rows */}
      <rect x="56" y="40" width="74" height="6" rx="2" fill="#f4dca0"/>
      <rect x="56" y="50" width="34" height="20" rx="2" fill="#8a2424"/>
      <rect x="94" y="50" width="36" height="20" rx="2" fill="#8a2424"/>
      <rect x="56" y="74" width="74" height="4" rx="2" fill="#c9a14a" opacity=".7"/>
      <rect x="56" y="82" width="54" height="4" rx="2" fill="#c9a14a" opacity=".5"/>
      {/* base */}
      <path d="M8 108 h144 l-10 16 H18 z" fill="url(#lt_base)"/>
      <rect x="64" y="108" width="32" height="4" rx="1" fill="#6b1d1d"/>
    </g>
  </svg>
);

const IconClassroomScene = (p) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" {...p}>
    <defs>
      <linearGradient id="board" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#8a6cb8"/>
        <stop offset="1" stopColor="#5a3c88"/>
      </linearGradient>
      <linearGradient id="dev" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#b89cdb"/>
        <stop offset="1" stopColor="#7a5aab"/>
      </linearGradient>
      <radialGradient id="chat" cx=".4" cy=".35" r=".8">
        <stop offset="0" stopColor="#ffcf9a"/>
        <stop offset="1" stopColor="#e8843a"/>
      </radialGradient>
    </defs>
    {/* chalkboard / monitor */}
    <rect x="14" y="20" width="78" height="54" rx="6" fill="url(#board)" stroke="#3e2867" strokeWidth="2.5"/>
    <rect x="20" y="26" width="66" height="42" rx="2" fill="#402a66" stroke="#3e2867" strokeWidth="1.5"/>
    {/* board drawings */}
    <circle cx="40" cy="40" r="5" fill="none" stroke="#ffffff" strokeWidth="2"/>
    <path d="M35 52 h10 M32 58 l8 -4 l8 4" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M58 36 l12 12 M70 36 l-12 12" stroke="#ffcf9a" strokeWidth="2.5" strokeLinecap="round"/>
    {/* stand */}
    <rect x="46" y="74" width="14" height="6" fill="#5a3c88" stroke="#3e2867" strokeWidth="1.5"/>
    <rect x="38" y="80" width="30" height="4" rx="2" fill="#3e2867"/>
    {/* small device front-right */}
    <rect x="62" y="72" width="40" height="28" rx="4" fill="url(#dev)" stroke="#3e2867" strokeWidth="2.2"/>
    <rect x="66" y="76" width="32" height="18" rx="1.5" fill="#2c1a4a" stroke="#3e2867" strokeWidth="1.5"/>
    <circle cx="82" cy="85" r="3.5" fill="#ffcf9a"/>
    {/* chat bubble top-right */}
    <circle cx="92" cy="26" r="14" fill="url(#chat)" stroke="#b85a12" strokeWidth="2.2"/>
    <path d="M84 34 l-4 6 l10 -4" fill="url(#chat)" stroke="#b85a12" strokeWidth="2.2" strokeLinejoin="round"/>
    <circle cx="86" cy="26" r="1.6" fill="#ffffff"/>
    <circle cx="92" cy="26" r="1.6" fill="#ffffff"/>
    <circle cx="98" cy="26" r="1.6" fill="#ffffff"/>
  </svg>
);

function fmtDate(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString(undefined, {
    year: "numeric", month: "short", day: "numeric",
  });
}

const ARTICLES_PER_PAGE = 6;

export default function HomePage() {
  const [articles, setArticles] = useState([]);
  const [programImages, setProgramImages] = useState({});
  const [content, setContent] = useState({});
  const [slide, setSlide] = useState(0);
  const [paused, setPaused] = useState(false);
  const [page, setPage] = useState(1);
  const [menuOpen, setMenuOpen] = useState(false);
  const dragRef = useRef({ startX: 0, dx: 0, dragging: false, moved: false });

  useEffect(() => {
    fetch(`${API_BASE}/api/articles`)
      .then(r => (r.ok ? r.json() : []))
      .then(list => setArticles(Array.isArray(list) ? list : []))
      .catch(() => setArticles([]));
    fetch(`${API_BASE}/api/program-images`)
      .then(r => (r.ok ? r.json() : {}))
      .then(obj => setProgramImages(obj || {}))
      .catch(() => setProgramImages({}));
    fetch(`${API_BASE}/api/site-content`)
      .then(r => (r.ok ? r.json() : {}))
      .then(obj => setContent(obj || {}))
      .catch(() => setContent({}));
  }, []);

  const t = (key) => pick(content, key);
  const admissionOn = t("admission.enabled").trim().toLowerCase() === "yes";

  // Featured = first 4 articles with media (fall back to any)
  const featured = (() => {
    const withMedia = articles.filter(a => a.mediaUrl);
    const pool = withMedia.length > 0 ? withMedia : articles;
    return pool.slice(0, 4);
  })();

  // Auto-advance the carousel every 5s (pause while dragging / hovering)
  useEffect(() => {
    if (featured.length <= 1 || paused) return;
    const t = setInterval(() => {
      setSlide(i => (i + 1) % featured.length);
    }, 5000);
    return () => clearInterval(t);
  }, [featured.length, paused]);

  // Keep slide index in range when articles change
  useEffect(() => {
    if (slide >= featured.length) setSlide(0);
  }, [featured.length, slide]);

  const prevSlide = () => {
    if (featured.length <= 1) return;
    setSlide(i => (i - 1 + featured.length) % featured.length);
  };
  const nextSlide = () => {
    if (featured.length <= 1) return;
    setSlide(i => (i + 1) % featured.length);
  };

  // ── Swipe / drag handlers ─────────────────────────────────────────
  const onDragStart = (clientX) => {
    dragRef.current = { startX: clientX, dx: 0, dragging: true, moved: false };
    setPaused(true);
  };
  const onDragMove = (clientX) => {
    if (!dragRef.current.dragging) return;
    const dx = clientX - dragRef.current.startX;
    dragRef.current.dx = dx;
    if (Math.abs(dx) > 6) dragRef.current.moved = true;
  };
  const onDragEnd = () => {
    if (!dragRef.current.dragging) return;
    const { dx } = dragRef.current;
    dragRef.current.dragging = false;
    if (dx > 50) prevSlide();
    else if (dx < -50) nextSlide();
    setPaused(false);
  };

  const handleSlideClick = (e) => {
    // Swallow the navigation if the user was actually swiping.
    if (dragRef.current.moved) {
      e.preventDefault();
      e.stopPropagation();
      dragRef.current.moved = false;
    }
  };

  return (
    <div className={s.landing}>
      {/* ── Navbar ── */}
      <nav className={s.navbar}>
        <Link to="/" className={s.logo}>
          <img src="/ncla-logo.png" alt="NCLA logo" className={s.logoIcon} />
          <div className={s.logoText}>
            <span className={s.logoAcronym}>NCLA</span>
            <span className={s.logoFull}>Northpoint Center for Learning and Advancement</span>
          </div>
        </Link>

        <div className={s.navLinks}>
          <a href="#about">About Us</a>
          <a href="#programs">Programs</a>
          <a href="#news">News &amp; Events</a>
          <a href="#contact">Contact</a>
          <PublicUserBadge variant="light" />
        </div>

        <div className={s.navActions}>
          <button
            type="button"
            className={s.menuBtn}
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen(o => !o)}
          >
            <span className={`${s.menuBar} ${menuOpen ? s.menuBarOpen1 : ""}`} />
            <span className={`${s.menuBar} ${menuOpen ? s.menuBarOpen2 : ""}`} />
            <span className={`${s.menuBar} ${menuOpen ? s.menuBarOpen3 : ""}`} />
          </button>
        </div>

        {menuOpen && (
          <div className={s.mobileMenu}>
            <a href="#about"    onClick={() => setMenuOpen(false)}>About Us</a>
            <a href="#programs" onClick={() => setMenuOpen(false)}>Programs</a>
            <a href="#news"     onClick={() => setMenuOpen(false)}>News &amp; Events</a>
            <a href="#contact"  onClick={() => setMenuOpen(false)}>Contact</a>
            <div onClick={() => setMenuOpen(false)} className={s.mobileMenuChip}>
              <PublicUserBadge variant="dark" />
            </div>
          </div>
        )}
      </nav>

      {admissionOn && t("admission.text") && (
        <div className={s.admissionBanner}>
          <span className={s.admissionLabel}>ADMISSIONS</span>
          <span className={s.admissionText}>{t("admission.text")}</span>
        </div>
      )}

      {/* ── Hero ── */}
      <section className={s.hero}>
        <div className={s.heroInner}>
          <div className={s.heroText}>
            <p className={s.eyebrow}>{t("hero.eyebrow")}</p>
            <h1 className={s.heroTitle} style={{ whiteSpace: "pre-line" }}>
              {t("hero.title")}
            </h1>
            <p className={s.heroSub}>{t("hero.sub")}</p>
            <div className={s.heroBtns}>
              <a href="#contact" className={s.btnPrimary}>Contact Us</a>
            </div>
            <p className={s.heroPhone}>
              Talk to a specialist <strong>{t("hero.phone")}</strong>
            </p>
          </div>

          <div className={s.heroVisual}>
            {featured.length > 0 ? (
              <div
                className={s.carousel}
                onMouseEnter={() => setPaused(true)}
                onMouseLeave={() => { setPaused(false); onDragEnd(); }}
              >
                <div
                  className={s.carouselTrack}
                  onTouchStart={(e) => onDragStart(e.touches[0].clientX)}
                  onTouchMove={(e) => onDragMove(e.touches[0].clientX)}
                  onTouchEnd={onDragEnd}
                  onMouseDown={(e) => onDragStart(e.clientX)}
                  onMouseMove={(e) => dragRef.current.dragging && onDragMove(e.clientX)}
                  onMouseUp={onDragEnd}
                >
                  {featured.map((a, i) => (
                    <Link
                      key={a.id}
                      to={`/news/${a.id}`}
                      className={`${s.carouselSlide} ${i === slide ? s.carouselSlideActive : ""}`}
                      aria-hidden={i !== slide}
                      onClick={handleSlideClick}
                      draggable={false}>
                      {a.mediaUrl ? (
                        a.mediaType === "video"
                          ? <video src={a.mediaUrl} autoPlay muted loop playsInline className={s.carouselMedia} />
                          : <img src={a.mediaUrl} alt={a.title} className={s.carouselMedia} draggable={false} />
                      ) : (
                        <div className={s.carouselPlaceholder}>📰</div>
                      )}
                      <div className={s.carouselOverlay}>
                        <span className={`${s.carouselBadge} ${a.category === "EVENT" ? s.carouselBadgeEvent : s.carouselBadgeNews}`}>
                          {a.category === "EVENT" ? "Event" : "News"}
                        </span>
                        <h3 className={s.carouselTitle}>{a.title}</h3>
                        {a.summary && <p className={s.carouselSummary}>{a.summary}</p>}
                        <span className={s.carouselCta}>Read article →</span>
                      </div>
                    </Link>
                  ))}
                </div>

                {featured.length > 1 && (
                  <>
                    <button
                      type="button"
                      className={`${s.carouselArrow} ${s.carouselArrowLeft}`}
                      onClick={prevSlide}
                      aria-label="Previous slide">
                      ‹
                    </button>
                    <button
                      type="button"
                      className={`${s.carouselArrow} ${s.carouselArrowRight}`}
                      onClick={nextSlide}
                      aria-label="Next slide">
                      ›
                    </button>

                    <div className={s.carouselDots}>
                      {featured.map((_, i) => (
                        <button
                          key={i}
                          type="button"
                          className={`${s.carouselDot} ${i === slide ? s.carouselDotActive : ""}`}
                          onClick={() => setSlide(i)}
                          aria-label={`Go to slide ${i + 1}`}
                        />
                      ))}
                    </div>
                  </>
                )}
              </div>
            ) : (
              <div className={s.heroPhone1}>
                <div className={s.phoneScreen}>
                  <div className={s.phoneHeader}>NCLA</div>
                  <div className={s.phoneCard}>
                    <div className={s.phoneRow}>
                      <span>Mathematics</span>
                      <span className={s.phoneGrade}>A</span>
                    </div>
                    <div className={s.phoneRow}>
                      <span>Science</span>
                      <span className={s.phoneGrade}>A-</span>
                    </div>
                    <div className={s.phoneRow}>
                      <span>English</span>
                      <span className={s.phoneGrade}>B+</span>
                    </div>
                  </div>
                  <div className={s.phoneBtn}>View Report</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ── About Us ── */}
      <section id="about" className={s.aboutSection}>
        <div className={s.aboutInner}>
          <span className={s.eyebrowDark}>{t("about.title")}</span>
          <Markdown text={t("about.body")} className={s.aboutBody} />
        </div>

        <div className={s.mvGrid}>
          <div className={s.mvCard}>
            <h3 className={s.mvTitle}>{t("mission.title")}</h3>
            <Markdown text={t("mission.body")} className={s.mvBody} />
          </div>
          <div className={s.mvCard}>
            <h3 className={s.mvTitle}>{t("vision.title")}</h3>
            <Markdown text={t("vision.body")} className={s.mvBody} />
          </div>
        </div>
      </section>

      {/* ── Programs / Quick Cards ── */}
      <section id="programs" className={s.stoneSection}>
        <div className={s.centerHead}>
          <h2 className={s.sectionTitle}>{t("programs.heading")}</h2>
        </div>
        <div className={s.cardRow}>
          {[
            { key: "preschool", slug: "preschool" },
            { key: "grade",     slug: "grade" },
            { key: "junior",    slug: "junior" },
            { key: "senior",    slug: "senior" },
          ].map(p => {
            const title   = t(`programs.${p.key}`);
            const tagline = t(`programs.${p.key}.tagline`);
            return (
              <Link key={p.key} to={`/programs/${p.slug}`} className={s.programCard}>
                {programImages[p.key] && (
                  <img src={programImages[p.key]} alt="" className={s.programPhoto} />
                )}
                <div className={s.programOverlay} />
                <div className={s.programBody}>
                  <span className={s.programLabel}>NCLA</span>
                  <h3 className={s.programTitle}>{title}</h3>
                  {tagline && <p className={s.programTagline}>{tagline}</p>}
                  <span className={s.programLink}>Learn more →</span>
                </div>
              </Link>
            );
          })}
        </div>
      </section>

      {/* ── Three Column Feature Section ── */}
      <section className={s.stoneSection}>
        <div className={s.centerHead}>
          <h2 className={s.sectionTitle}>However you teach, we've got you</h2>
        </div>
        <div className={s.threeCol}>
          <div className={s.col}>
            <div className={s.colScene}><IconDashboardLaptop width="130" height="130"/></div>
            <h3>Don't miss a student</h3>
            <p>
              Track attendance, grades, and progress across every program from
              one unified dashboard.
            </p>
          </div>
          <div className={s.col}>
            <div className={s.colScene}><IconIntegrateLaptop width="130" height="130"/></div>
            <h3>Integrate seamlessly</h3>
            <p>
              Works with your existing tools—calendars, messaging, and tuition
              systems all in one place.
            </p>
          </div>
          <div className={s.col}>
            <div className={s.colScene}><IconSecurityDoc width="130" height="130"/></div>
            <h3>Security you can trust</h3>
            <p>
              Role‑based access, audit logs, and privacy controls designed for
              schools and families.
            </p>
          </div>
        </div>
      </section>

      {/* ── Section Header ── */}
      <section className={s.whiteSection}>
        <div className={s.centerHead}>
          <h2 className={s.sectionTitleDark}>Run your school wherever you are</h2>
        </div>

        {/* ── Two Feature Cards ── */}
        <div className={s.twoCardRow}>
          <div className={s.wrapCard}>
            <div className={s.wrapCardIconBox}>
              <IconEnrollScene width="120" height="120"/>
            </div>
            <div className={s.wrapCardText}>
              <h3>Manage enrollment online</h3>
              <p>
                Accept applications, review documents, and onboard students
                without any paper forms.
              </p>
              <Link to="/login" className={s.btnOutline}>Get started</Link>
            </div>
          </div>

          <div className={`${s.wrapCard} ${s.wrapCardPurple}`}>
            <div className={`${s.wrapCardIconBox} ${s.wrapCardIconBoxPurple}`}>
              <IconClassroomScene width="120" height="120"/>
            </div>
            <div className={s.wrapCardText}>
              <h3>Connect every classroom</h3>
              <p>
                Sync announcements, materials, and grades across teachers,
                students, and guardians in real time.
              </p>
              <Link to="/login" className={s.btnOutline}>Explore tools</Link>
            </div>
          </div>
        </div>
      </section>

      {/* ── Slate Section ── */}
      <section className={s.slateSection}>
        <h2 className={s.slateTitle}>Teach globally without a second system</h2>
        <p className={s.slateDesc}>
          NCLA connects your classrooms, coaches, and families through one
          reliable platform—no matter where they are.
        </p>
      </section>

      {/* ── Stack / Three Feature Columns ── */}
      <section className={s.whiteSection}>
        <div className={s.stackImage}>
          <div className={s.stackFig}><IconAnnounceClipboard width="150" height="150"/></div>
          <div className={s.stackFig}><IconSchedulePhone width="150" height="150"/></div>
          <div className={s.stackFig}><IconTuitionLaptop width="150" height="150"/></div>
        </div>
        <div className={s.threeCol}>
          <div className={s.featureCard}>
            <h3>Send announcements</h3>
            <p>Broadcast updates to parents and students the moment they matter.</p>
            <Link to="/login" className={s.featureBtn}>Get started</Link>
          </div>
          <div className={s.featureCard}>
            <h3>Share a schedule</h3>
            <p>Publish class timetables and events with a single link.</p>
            <Link to="/login" className={s.featureBtn}>Get started</Link>
          </div>
          <div className={s.featureCard}>
            <h3>Collect tuition</h3>
            <p>Offer recurring payments and track balances in one place.</p>
            <Link to="/login" className={s.featureBtn}>Get started</Link>
          </div>
        </div>
      </section>

      {/* ── Pricing Card ── */}
      <section className={s.stoneSection}>
        <div className={s.pricingCard}>
          <span className={s.pricingEyebrow}>SIMPLE &amp; TRANSPARENT</span>
          <h2 className={s.pricingTitle}>Simple, transparent pricing</h2>
          <p className={s.pricingSub}>No setup fees. Pay only for what you use.</p>

          <div className={s.pricingBadges}>
            <span className={s.pricingBadge}>
              <span className={s.pricingBadgeIcon}>✓</span> No setup fees
            </span>
            <span className={s.pricingBadge}>
              <span className={s.pricingBadgeIcon}>✓</span> No hidden costs
            </span>
            <span className={s.pricingBadge}>
              <span className={s.pricingBadgeIcon}>↻</span> Cancel anytime
            </span>
          </div>

          <div className={s.pricingBtns}>
            <Link to="/login" className={s.btnPrimary}>See pricing</Link>
            <Link to="/login" className={s.btnOutline}>View demo</Link>
          </div>

          <p className={s.pricingTrust}>
            <span className={s.pricingTrustDot}>✓</span> Trusted by growing schools
          </p>
        </div>
      </section>

      {/* ── The Latest News ── */}
      {articles.length > 0 && (() => {
        const totalPages = Math.max(1, Math.ceil(articles.length / ARTICLES_PER_PAGE));
        const safePage = Math.min(page, totalPages);
        const start = (safePage - 1) * ARTICLES_PER_PAGE;
        const pageItems = articles.slice(start, start + ARTICLES_PER_PAGE);
        return (
          <section id="news" className={s.whiteSection}>
            <div className={s.centerHead}>
              <h2 className={s.sectionTitleDark}>The Latest News</h2>
            </div>
            <div className={s.articlesGrid}>
              {pageItems.map(a => (
                <Link key={a.id} to={`/news/${a.id}`} className={s.homeArticle}>
                  {a.mediaUrl && (
                    <div className={s.homeArticleMedia}>
                      {a.mediaType === "video" ? (
                        <>
                          <video
                            src={a.mediaUrl}
                            muted
                            playsInline
                            preload="metadata"
                            onMouseEnter={e => e.currentTarget.play().catch(()=>{})}
                            onMouseLeave={e => { e.currentTarget.pause(); e.currentTarget.currentTime = 0; }}
                          />
                          <span className={s.videoBadge}>▶</span>
                        </>
                      ) : (
                        <img src={a.mediaUrl} alt={a.title} />
                      )}
                    </div>
                  )}
                  <div className={s.homeArticleBody}>
                    <div className={s.homeArticleMeta}>
                      <span className={`${s.homeBadge} ${a.category === "EVENT" ? s.homeBadgeEvent : s.homeBadgeNews}`}>
                        {a.category === "EVENT" ? "Event" : "News"}
                      </span>
                      <span className={s.homeArticleDate}>{fmtDate(a.postedAt)}</span>
                    </div>
                    <h3 className={s.homeArticleTitle}>{a.title}</h3>
                    {a.summary && <p className={s.homeArticleSummary}>{a.summary}</p>}
                    <span className={s.homeReadMore}>Read more →</span>
                  </div>
                </Link>
              ))}
            </div>

            {totalPages > 1 && (
              <div className={s.pagination}>
                <button
                  type="button"
                  className={s.pageBtn}
                  onClick={() => setPage(p => Math.max(1, p - 1))}
                  disabled={safePage === 1}
                  aria-label="Previous page"
                >‹</button>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(n => (
                  <button
                    key={n}
                    type="button"
                    className={`${s.pageBtn} ${n === safePage ? s.pageBtnActive : ""}`}
                    onClick={() => setPage(n)}
                  >{n}</button>
                ))}
                <button
                  type="button"
                  className={s.pageBtn}
                  onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                  disabled={safePage === totalPages}
                  aria-label="Next page"
                >›</button>
              </div>
            )}
          </section>
        );
      })()}

      {/* ── Final CTA / Contact ── */}
      <section id="contact" className={s.ctaSection}>
        <h2 className={s.ctaTitle}>We support schools just like yours</h2>
        <p className={s.ctaDesc}>
          Join hundreds of schools and educators using NCLA to deliver
          better learning experiences every day.
        </p>
        <div className={s.contactGrid}>
          {t("contact.phone") && (
            <div className={s.contactItem}>
              <span className={s.contactLabel}>Phone</span>
              <span className={s.contactValue}>{t("contact.phone")}</span>
            </div>
          )}
          {t("contact.email") && (
            <div className={s.contactItem}>
              <span className={s.contactLabel}>Email</span>
              <span className={s.contactValue}>{t("contact.email")}</span>
            </div>
          )}
          {t("contact.address") && (
            <div className={s.contactItem}>
              <span className={s.contactLabel}>Address</span>
              <span className={s.contactValue} style={{ whiteSpace: "pre-line" }}>
                {t("contact.address")}
              </span>
            </div>
          )}
        </div>
      </section>

      {/* ── Footer ── */}
      <footer className={s.footer}>
        <div className={s.footerGrid}>
          <div className={s.footerBrand}>
            <div className={s.footerLogo}>
              <img src="/ncla-logo.png" alt="NCLA logo" className={s.footerLogoIcon} />
              NCLA
            </div>
            <p className={s.footerDesc} style={{ whiteSpace: "pre-line" }}>
              {t("footer.description")}
            </p>
          </div>

          <div className={s.footerCol}>
            <h4>Platform</h4>
            <a href="#programs">Programs</a>
            <a href="#courses">Courses</a>
            <a href="#workshops">Workshops</a>
          </div>

          <div className={s.footerCol}>
            <h4>Resources</h4>
            <a href="#help">Documentation</a>
            <a href="#help">Support</a>
            <a href="#help">FAQ</a>
          </div>

          <div className={s.footerCol}>
            <h4>Connect</h4>
            <a href="#contact">Email Us</a>
            <a href="#contact">Twitter</a>
            <a href="#contact">LinkedIn</a>
          </div>
        </div>

        <div className={s.footerBottom}>
          <span>{t("footer.copyright")}</span>
          <div className={s.footerSocial}>
            <a href="#">Privacy</a>
            <a href="#">Cookies</a>
            <a href="#">Legal</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
